import.meta.glob(['../images/**']);
import { initParallax } from './partials/parallax';
import { initSlider } from './partials/slider';
import { initScrollspy } from './partials/scrollspy';
import { initReveal } from './partials/reveal';
import { initLoadBackgroundImages } from './partials/background';

window.onload = () => {
    initParallax();
    initSlider();
    initScrollspy();
    initReveal();
    initLoadBackgroundImages();
};
